import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Dialog } from '@/components/ui/Dialog'
import { Button } from '@/components/ui/Button'
import type { WorkspaceMember } from '@/api/types'

interface RemoveMemberDialogProps {
  open: boolean
  onClose: () => void
  member: WorkspaceMember | null
  onConfirm: (memberId: number) => Promise<void>
}

export function RemoveMemberDialog({
  open,
  onClose,
  member,
  onConfirm,
}: RemoveMemberDialogProps) {
  const { t } = useTranslation()
  const [loading, setLoading] = useState(false)

  async function handleConfirm() {
    if (!member) return
    setLoading(true)
    try {
      await onConfirm(member.id)
      onClose()
    } finally {
      setLoading(false)
    }
  }

  const displayName = member?.user.name || member?.user.email || '—'

  return (
    <Dialog
      open={open}
      title={t('members.removeDialog.title')}
      onClose={onClose}
      footer={
        <>
          <Button variant="ghost" onClick={onClose} disabled={loading}>
            {t('common.cancel')}
          </Button>
          <Button variant="danger" onClick={() => void handleConfirm()} disabled={loading}>
            {loading ? t('members.removeDialog.removing') : t('members.removeDialog.confirm')}
          </Button>
        </>
      }
    >
      <p
        style={{ margin: 0, color: 'var(--text-muted)', lineHeight: 1.5 }}
        dangerouslySetInnerHTML={{
          __html: t('members.removeDialog.message', { name: displayName }),
        }}
      />
    </Dialog>
  )
}
